/* ============================================================================
FILE: po-katupirsia5-aisthera-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5AistheraTextsFR_EN_ES_20260312
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_AISTHERA_TEXTS_20260312__) return;
  window.__PO_K5_AISTHERA_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="aisthera"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) {
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Système posœnnoïal",
      "Organon posœnnoïal",
      "Posœnnoïamie",
      "Posœnnomia",
      "Katûpirsia",
      "Katûvýs",
      "Katûsýs",
      "Katûvýsqun",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone régulateur",
      "Sceau de Syntonie",
      "Sceau d’Équiphase",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí",
      "Sceau d’Ọ̀rọ̀yuyay",
      "Sceau de Yuyarina",
      "Sceau d’Œndomare",
      "Syntōnēa",
      "Ēkuphasa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Takimarah",
      "Ušôprogalenmestûd",
      "Mathêsis ontologique",
      "Pistis Chraomai",
      "RéZonans",
      "RéZonanser",
      "RéZoindre",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Stratification d’expériences",
      "Expérience fragmentée",
      "Conscientisation introspective",
      "Conscientisation dynamique",
      "Conscience vibratoire",
      "Lucidité critique",
      "Lucidité structurante",
      "Adaptabilité critique",
      "Adaptabilité ouverte",
      "Approche fluide et adaptative",
      "Déterminisme du choix",
      "Myrte décisif",
      "Néotaxie",
      "Identité évolutive",
      "Exploration de l’inconnu",
      "Miroirs posœnnoïaux",
      "Fréquence 492",
      "Fréquence-guide",
      "Nombre-guide",
      "Humanus",
      "MOCoN",
      "Àpákan",
      "VITRIOL"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  var CANONICAL_OVERRIDES = [
    [/\bGuide-number\b/gi, "Nombre-guide"],
    [/\bGuide number\b/gi, "Nombre-guide"],
    [/\bN[uú]mero-gu[ií]a\b/gi, "Nombre-guide"],
    [/\bGuide-frequency\b/gi, "Fréquence-guide"],
    [/\bGuide frequency\b/gi, "Fréquence-guide"],
    [/\bFrecuencia-gu[ií]a\b/gi, "Fréquence-guide"],
    [/\bFrequency 492\b/gi, "Fréquence 492"],
    [/\bFrecuencia 492\b/gi, "Fréquence 492"],
    [/\bAssociated seal\b/gi, "Sceau associé"],
    [/\bSello asociado\b/gi, "Sceau associé"],
    [/\bSeal of Aisthisi\b/gi, "Sceau d’Aísthisi"],
    [/\bSello de A[ií]sthisi\b/gi, "Sceau d’Aísthisi"],
    [/\bIsqunian entity\b/gi, "Entité isqunienne"],
    [/\bEntidad isquniana\b/gi, "Entité isqunienne"],
    [/\bThrenisqun entity\b/gi, "Entité de Threnisqun"],
    [/\bEntidad de Threnisqun\b/gi, "Entité de Threnisqun"],
    [/\bOntological Mathesis\b/gi, "Mathêsis ontologique"],
    [/\bMathesis ontol[oó]gica\b/gi, "Mathêsis ontologique"],
    [/\bPosœnnoïal meditations\b/gi, "Méditations Posœnnoïales"],
    [/\bMeditaciones posœnnoïales\b/gi, "Méditations Posœnnoïales"],
    [/\bPosœnnoïal agreements\b/gi, "Accords Posœnnoïaux"],
    [/\bAcuerdos posœnnoïaux\b/gi, "Accords Posœnnoïaux"],
    [/\bPlural subject\b/gi, "Sujet pluriel"],
    [/\bSujeto plural\b/gi, "Sujet pluriel"],
    [/\bSuperposition of perspectives\b/gi, "Superposition de perspectives"],
    [/\bSuperposici[oó]n de perspectivas\b/gi, "Superposition de perspectives"],
    [/\bMultiple instantaneity\b/gi, "Instantané multiple"],
    [/\bInstant[aá]neo m[uú]ltiple\b/gi, "Instantané multiple"],
    [/\bExpanded temporality\b/gi, "Temporalité élargie"],
    [/\bTemporalidad extensiva\b/gi, "Temporalité élargie"],
    [/\bBroken-out temporality\b/gi, "Temporalité éclatée"],
    [/\bTemporalidad estallada\b/gi, "Temporalité éclatée"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  var CONTENT = {
    fr: {
      title: "Aísthēra",
      kicker: "Entité isqunienne de Threnisqun — filtre vivant des saturations perceptives et synesthésiques.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aisthera_copie.png?v=1772923205", alt: "Idéogramme de Aísthēra" },

      h_def: "Définition canonique",

      chip_1: "Sceau associé : Sceau d’Aísthisi",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2.png?v=1772896688", alt: "Sceau d’Aísthisi" },
      chip_2: "Fréquence d’alignement 720",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_720.png?v=1773448446", alt: "Nombre-guide 720" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Aísthēra</strong> capte les excès sensoriels et synesthésiques, les filtre par une membrane vibratoire adaptative, puis redistribue l’intensité afin que la perception redevienne habitable, lisible et non intrusive.",

      def_long:
        "<p><strong>Aísthēra</strong> est l’entité posœnnoïale gardienne des seuils sensoriels. Elle intervient lorsque les perceptions — visuelles, auditives, olfactives, tactiles, énergétiques — deviennent trop intenses, trop confondues ou trop fragmentées.</p>" +
        "<p>Dans la logique <strong>Isqun → Threnisqun</strong>, elle incarne le passage de la fréquence à la densité opérative : ce qui, dans le <strong>Sceau d’Aísthisi</strong>, relève d’une régulation de fond devient ici présence activable, résidu actif de la régulation rituélique.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Aísthisi</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "720",
      grid_scope_label: "Champ et portée",
      grid_scope_value:
        "<ul>" +
        "<li>Régulation des saturations perceptives et synesthésiques</li>" +
        "<li>Filtre adaptatif entre corps sensoriel et champ vibratoire</li>" +
        "<li>Complétude sensitive : 360 × 2, symétrie intérieur / extérieur</li>" +
        "</ul>",

      h_intro: "Statut vibratoire",
      p_intro:
        "<p>Le nom <strong>Aísthēra</strong> se rattache à αἴσθησις (<em>aisthēsis</em>), sensation et perception vive, avec le suffixe <em>-ēra</em>, donné comme agent féminin de régulation vibratoire. Sa formule interne est conservée telle quelle : « Celle qui régule l’intensité des mondes sensoriels en excès. »</p>" +
        "<p>Elle apparaît lorsque le sensible excède la capacité d’assimilation : surcharge visuelle, confusion auditive, hypermnésie sensitive, synesthésie perturbatrice, fatigue perceptive, environnements hautement stimulants. Son œuvre consiste à ralentir l’afflux, décomposer le trop-plein, et rendre la perception à nouveau juste.</p>",

      h_actions: "Fonctions rituelles",
      actions:
        "<ol>" +
        "<li>Réguler les débordements sensoriels : hypersensibilité, surcharge visuelle, confusion perceptive.</li>" +
        "<li>Réactiver les canaux d’écoute : vue intérieure, ouïe vibratoire, toucher éthérique.</li>" +
        "<li>Transmuter les signaux bruyants en perceptions nuancées et intégrables.</li>" +
        "<li>Soutenir les états de synesthésie perturbatrice ou d’hypermnésie sensitive.</li>" +
        "<li>Créer un espace tampon vibratoire dans les environnements hautement stimulants.</li>" +
        "</ol>",

      h_phrase: "Formule opérative",
      phrase:
        "<p>« Aísthēra : je ralentis l’afflux, je laisse le filtre vivant redistribuer l’intensité, et la perception redevient habitable. »</p>",

      h_table: "Tableau récapitulatif",
      table_head_1: "Élément",
      table_head_2: "Contenu",
      table_head_3: "Portée",
      table_rows:
        "<tr><td>Nom</td><td>Aísthēra</td><td>Entité isqunienne de régulation sensorielle</td></tr>" +
        "<tr><td>Sceau associé</td><td>Sceau d’Aísthisi</td><td>Seuil perceptif et filtrage vivant</td></tr>" +
        "<tr><td>Fréquence d’alignement</td><td>720</td><td>Complétude sensitive 360 × 2</td></tr>" +
        "<tr><td>Fonction principale</td><td>Régulation des saturations perceptives et synesthésiques</td><td>Rendre la perception habitable</td></tr>" +
        "<tr><td>Champ vibratoire</td><td>Sensorialité intense, synesthésie, hypermnésie sensitive</td><td>Stabilisation de l’afflux sensible</td></tr>" +
        "<tr><td>Mode d’invocation</td><td>Silence – lumière – souffle du seuil sensoriel</td><td>Activation douce et ajustée</td></tr>",

      h_entite: "Entité associée",
      entite_kicker: "Présence filtrante du Threnisqun",
      entite_body:
        "<p><strong>Aísthēra</strong> agit comme membrane vibratoire entre le corps sensoriel et le champ du monde. Elle reçoit l’excès, le ralentit, le trie, le redistribue.</p>" +
        "<p>Sa présence se manifeste dans les états de surcharge perceptive, de synesthésie perturbatrice, de fatigue sensible ou d’hyper-réceptivité. Elle garde le seuil sans dessécher l’intensité du vivant.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Tapis de perception silencieuse",
      ritual_steps:
        "<ol>" +
        "<li>S’allonger sur le sol, yeux clos.</li>" +
        "<li>Respirer profondément 9 fois, en expirant lentement par la bouche.</li>" +
        "<li>Visualiser une lumière blanc-bleutée émanant des paumes, se diffusant dans l’air comme un voile.</li>" +
        "<li>Répéter mentalement : « Aísthēra, filtre vivant, seuil de lumière. »</li>" +
        "<li>Se relever en silence, les yeux encore clos, puis écouter les sons du monde avec neutralité.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Après une longue exposition sensorielle : foule, bruit, couleurs vives</li>" +
        "<li>Lors de confusion sensorielle ou d’angoisse liée à une perception accrue</li>" +
        "<li>Avant une performance artistique impliquant plusieurs sens</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Mathêsis ontologique</strong> — transforme les perceptions en sens structuré</li>" +
        "<li><strong>Lulæṣírasen</strong> — ralentit la spirale quand elle devient vertigineuse ou écrasante</li>" +
        "<li><strong>Tiqqunbahu</strong> — décompose les fragments sensoriels en unités poïétiques intégrables</li>" +
        "<li><strong>Katûvýsissence</strong> — stabilise les mémoires sensorielles en souffrance</li>" +
        "<li><strong>VITRIOL</strong> — peut être activé lors des phases de surcharge sensitive pendant le rituel</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Aísthēra",
      kicker: "Entité isqunienne de Threnisqun — living filter of perceptive and synesthetic overloads.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aisthera_copie.png?v=1772923205", alt: "Idéogramme de Aísthēra" },

      h_def: "Canonical definition",

      chip_1: "Sceau associé : Sceau d’Aísthisi",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2.png?v=1772896688", alt: "Sceau d’Aísthisi" },
      chip_2: "Fréquence d’alignement 720",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_720.png?v=1773448446", alt: "Nombre-guide 720" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Aísthēra</strong> captures sensory and synesthetic excess, filters it through an adaptive vibratory membrane, then redistributes intensity so perception becomes habitable, legible, and non-intrusive again.",

      def_long:
        "<p><strong>Aísthēra</strong> is the posœnnoïal entity guarding sensory thresholds. It intervenes when perceptions — visual, auditory, olfactory, tactile, energetic — become too intense, too confused, or too fragmented.</p>" +
        "<p>Within the <strong>Isqun → Threnisqun</strong> logic, it embodies the passage from frequency to operative density: what belongs to background regulation in the <strong>Sceau d’Aísthisi</strong> becomes activable presence here, an active residue of ritual regulation.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Aísthisi</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "720",
      grid_scope_label: "Field and reach",
      grid_scope_value:
        "<ul>" +
        "<li>Regulation of perceptive and synesthetic saturations</li>" +
        "<li>Adaptive filter between the sensory body and the vibratory field</li>" +
        "<li>Sensitive completeness: 360 × 2, inner / outer symmetry</li>" +
        "</ul>",

      h_intro: "Vibratory status",
      p_intro:
        "<p>The name <strong>Aísthēra</strong> is linked to αἴσθησις (<em>aisthēsis</em>), sensation and vivid perception, with the suffix <em>-ēra</em>, given as a feminine agent of vibratory regulation. Its internal formula remains explicit: “Celle qui régule l’intensité des mondes sensoriels en excès.”</p>" +
        "<p>It appears when the sensible exceeds the capacity of assimilation: visual overload, auditory confusion, sensitive hypermnesia, disruptive synesthesia, perceptive fatigue, highly stimulating environments. Its work is to slow the influx, decompose the excess, and make perception just again.</p>",

      h_actions: "Ritual functions",
      actions:
        "<ol>" +
        "<li>Regulate sensory overflow: hypersensitivity, visual overload, perceptive confusion.</li>" +
        "<li>Reactivate channels of listening: inner sight, vibratory hearing, etheric touch.</li>" +
        "<li>Transmute noisy signals into nuanced and integrable perceptions.</li>" +
        "<li>Support states of disruptive synesthesia or sensitive hypermnesia.</li>" +
        "<li>Create a vibratory buffer zone in highly stimulating environments.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "<p>“Aísthēra: I slow the influx, I let the living filter redistribute intensity, and perception becomes habitable again.”</p>",

      h_table: "Summary table",
      table_head_1: "Element",
      table_head_2: "Content",
      table_head_3: "Reach",
      table_rows:
        "<tr><td>Name</td><td>Aísthēra</td><td>Entité isqunienne of sensory regulation</td></tr>" +
        "<tr><td>Sceau associé</td><td>Sceau d’Aísthisi</td><td>Perceptive threshold and living filter</td></tr>" +
        "<tr><td>Fréquence d’alignement</td><td>720</td><td>Sensitive completeness 360 × 2</td></tr>" +
        "<tr><td>Main function</td><td>Regulation of perceptive and synesthetic saturations</td><td>Making perception habitable again</td></tr>" +
        "<tr><td>Vibratory field</td><td>Intense sensoriality, synesthesia, sensitive hypermnesia</td><td>Stabilization of sensory influx</td></tr>" +
        "<tr><td>Mode d’invocation</td><td>Silence – lumière – souffle du seuil sensoriel</td><td>Gentle and adjusted activation</td></tr>",

      h_entite: "Associated entity",
      entite_kicker: "Présence filtrante du Threnisqun",
      entite_body:
        "<p><strong>Aísthēra</strong> acts as a vibratory membrane between the sensory body and the field of the world. It receives excess, slows it, sorts it, redistributes it.</p>" +
        "<p>Its presence appears in states of perceptive overload, disruptive synesthesia, sensory fatigue, or hyper-receptivity. It guards the threshold without drying out the intensity of the living.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Tapis de perception silencieuse",
      ritual_steps:
        "<ol>" +
        "<li>Lie down on the ground, eyes closed.</li>" +
        "<li>Breathe deeply 9 times, exhaling slowly through the mouth.</li>" +
        "<li>Visualize a bluish-white light emanating from the palms and diffusing into the air like a veil.</li>" +
        "<li>Repeat mentally: “Aísthēra, filtre vivant, seuil de lumière.”</li>" +
        "<li>Rise in silence, eyes still closed, then listen to the sounds of the world with neutrality.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>After long sensory exposure: crowd, noise, vivid colors</li>" +
        "<li>During sensory confusion or anxiety linked to heightened perception</li>" +
        "<li>Before an artistic performance involving several senses</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Mathêsis ontologique</strong> — transforms perceptions into structured meaning</li>" +
        "<li><strong>Lulæṣírasen</strong> — slows the spiral when it becomes dizzying or crushing</li>" +
        "<li><strong>Tiqqunbahu</strong> — decomposes sensory fragments into integrable poïetic units</li>" +
        "<li><strong>Katûvýsissence</strong> — stabilizes suffering sensory memories</li>" +
        "<li><strong>VITRIOL</strong> — may be activated during phases of sensory overload within the ritual</li>" +
        "</ul>",

      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Aísthēra",
      kicker: "Entité isqunienne de Threnisqun — filtro vivo de las saturaciones perceptivas y sinestésicas.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aisthera_copie.png?v=1772923205", alt: "Idéogramme de Aísthēra" },

      h_def: "Definición canónica",

      chip_1: "Sceau associé : Sceau d’Aísthisi",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2.png?v=1772896688", alt: "Sceau d’Aísthisi" },
      chip_2: "Fréquence d’alignement 720",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_720.png?v=1773448446", alt: "Nombre-guide 720" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Aísthēra</strong> capta los excesos sensoriales y sinestésicos, los filtra por una membrana vibratoria adaptativa y redistribuye la intensidad para que la percepción vuelva a ser habitable, legible y no intrusiva.",

      def_long:
        "<p><strong>Aísthēra</strong> es la entidad posœnnoïal guardiana de los umbrales sensoriales. Interviene cuando las percepciones — visuales, auditivas, olfativas, táctiles, energéticas — se vuelven demasiado intensas, demasiado confundidas o demasiado fragmentadas.</p>" +
        "<p>En la lógica <strong>Isqun → Threnisqun</strong>, encarna el paso de la frecuencia a la densidad operativa: lo que, en el <strong>Sceau d’Aísthisi</strong>, pertenece a una regulación de fondo se vuelve aquí presencia activable, residuo activo de la regulación ritual.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Aísthisi</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "720",
      grid_scope_label: "Campo y alcance",
      grid_scope_value:
        "<ul>" +
        "<li>Regulación de las saturaciones perceptivas y sinestésicas</li>" +
        "<li>Filtro adaptativo entre cuerpo sensorial y campo vibratorio</li>" +
        "<li>Completitud sensitiva: 360 × 2, simetría interior / exterior</li>" +
        "</ul>",

      h_intro: "Estatuto vibratorio",
      p_intro:
        "<p>El nombre <strong>Aísthēra</strong> se vincula a αἴσθησις (<em>aisthēsis</em>), sensación y percepción viva, con el sufijo <em>-ēra</em>, dado como agente femenino de regulación vibratoria. Su fórmula interna permanece explícita: « Celle qui régule l’intensité des mondes sensoriels en excès. »</p>" +
        "<p>Aparece cuando lo sensible excede la capacidad de asimilación: sobrecarga visual, confusión auditiva, hipermnesia sensitiva, sinestesia perturbadora, fatiga perceptiva, entornos altamente estimulantes. Su obra consiste en ralentizar el flujo, descomponer el exceso y devolver justicia a la percepción.</p>",

      h_actions: "Funciones rituales",
      actions:
        "<ol>" +
        "<li>Regular los desbordamientos sensoriales: hipersensibilidad, sobrecarga visual, confusión perceptiva.</li>" +
        "<li>Reactivar los canales de escucha: visión interior, oído vibratorio, tacto etérico.</li>" +
        "<li>Transmutar las señales ruidosas en percepciones matizadas e integrables.</li>" +
        "<li>Sostener los estados de sinestesia perturbadora o de hipermnesia sensitiva.</li>" +
        "<li>Crear un espacio tampón vibratorio en entornos altamente estimulantes.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "<p>« Aísthēra : ralento el influjo, dejo que el filtro vivo redistribuya la intensidad, y la percepción vuelve a ser habitable. »</p>",

      h_table: "Tabla recapitulativa",
      table_head_1: "Elemento",
      table_head_2: "Contenido",
      table_head_3: "Alcance",
      table_rows:
        "<tr><td>Nombre</td><td>Aísthēra</td><td>Entité isqunienne de regulación sensorial</td></tr>" +
        "<tr><td>Sceau associé</td><td>Sceau d’Aísthisi</td><td>Umbral perceptivo y filtro vivo</td></tr>" +
        "<tr><td>Fréquence d’alignement</td><td>720</td><td>Completitud sensitiva 360 × 2</td></tr>" +
        "<tr><td>Función principal</td><td>Regulación de las saturaciones perceptivas y sinestésicas</td><td>Volver habitable la percepción</td></tr>" +
        "<tr><td>Campo vibratorio</td><td>Sensorialidad intensa, sinestesia, hipermnesia sensitiva</td><td>Estabilización del influjo sensible</td></tr>" +
        "<tr><td>Mode d’invocation</td><td>Silence – lumière – souffle du seuil sensoriel</td><td>Activación suave y ajustada</td></tr>",

      h_entite: "Entidad asociada",
      entite_kicker: "Présence filtrante du Threnisqun",
      entite_body:
        "<p><strong>Aísthēra</strong> actúa como membrana vibratoria entre el cuerpo sensorial y el campo del mundo. Recibe el exceso, lo ralentiza, lo ordena, lo redistribuye.</p>" +
        "<p>Su presencia aparece en estados de sobrecarga perceptiva, sinestesia perturbadora, fatiga sensible o hiper-receptividad. Custodia el umbral sin secar la intensidad de lo vivo.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Tapis de perception silencieuse",
      ritual_steps:
        "<ol>" +
        "<li>Tumbarse en el suelo, con los ojos cerrados.</li>" +
        "<li>Respirar profundamente 9 veces, exhalando lentamente por la boca.</li>" +
        "<li>Visualizar una luz blanco-azulada que emana de las palmas y se difunde en el aire como un velo.</li>" +
        "<li>Repetir mentalmente: « Aísthēra, filtre vivant, seuil de lumière. »</li>" +
        "<li>Levantarse en silencio, todavía con los ojos cerrados, y escuchar los sonidos del mundo con neutralidad.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Después de una larga exposición sensorial: multitud, ruido, colores vivos</li>" +
        "<li>Durante confusión sensorial o angustia ligada a una percepción aumentada</li>" +
        "<li>Antes de una performance artística que implique varios sentidos</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Mathêsis ontologique</strong> — transforma las percepciones en sentido estructurado</li>" +
        "<li><strong>Lulæṣírasen</strong> — ralentiza la espiral cuando se vuelve vertiginosa o aplastante</li>" +
        "<li><strong>Tiqqunbahu</strong> — descompone los fragmentos sensoriales en unidades poïétiques integrables</li>" +
        "<li><strong>Katûvýsissence</strong> — estabiliza las memorias sensoriales en sufrimiento</li>" +
        "<li><strong>VITRIOL</strong> — puede activarse durante fases de sobrecarga sensitiva dentro del ritual</li>" +
        "</ul>",

      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try {
        PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle");
      } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) {
        cur += " " + piece;
      } else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", kind: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, kind: "block", text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = (normLang(lang) || "fr");
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;
    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) {
      meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    } else if (defShort && defShort.parentNode) {
      defShort.parentNode.insertBefore(generalBtn, defShort);
    } else if (firstDetails && firstDetails.parentNode) {
      firstDetails.parentNode.insertBefore(generalBtn, firstDetails);
    }

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_type_value", "grid_freq_value", "grid_scope_value", "p_intro",
      "actions", "phrase", "table_rows", "entite_body", "ritual_name_value", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");

    syncDocumentLang(safeLang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }
    initAudioEverywhere(safeLang);

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5AistheraInit) return;
    root.__poK5AistheraInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5AistheraTextsFR_EN_ES_20260312 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    }catch(e){}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
